import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ComparisonView = ({ inspectionData, sections }) => {
  const [selectedSection, setSelectedSection] = useState(null);
  const [isExpanded, setIsExpanded] = useState(false);

  // Mock pre-rental photos (in real implementation, these would come from database)
  const preRentalPhotos = {
    exterior: [
    { id: 1, url: "https://img.rocket.new/generatedImages/rocket_gen_img_1f10659b2-1770844445177.png", alt: 'Pre-rental exterior front' },
    { id: 2, url: "https://img.rocket.new/generatedImages/rocket_gen_img_1eb6b1777-1770844445620.png", alt: 'Pre-rental exterior side' }],

    interior: [
    { id: 3, url: "https://img.rocket.new/generatedImages/rocket_gen_img_1f214e6a8-1766743250051.png", alt: 'Pre-rental interior' }]

  };

  const hasPreRentalPhotos = Object.keys(preRentalPhotos)?.length > 0;
  const hasReturnPhotos = Object.keys(inspectionData)?.length > 0;

  if (!hasPreRentalPhotos || !hasReturnPhotos) {
    return null;
  }

  const sectionsWithComparison = sections?.filter((section) =>
  preRentalPhotos?.[section?.id] && inspectionData?.[section?.id]?.photos?.length > 0
  );

  if (sectionsWithComparison?.length === 0) {
    return null;
  }

  return (
    <div className="bg-card rounded-lg shadow-elevation-2 overflow-hidden">
      {/* Header */}
      <button
        onClick={() => setIsExpanded(!isExpanded)}
        className="w-full p-4 flex items-center justify-between hover:bg-muted/50 transition-smooth">
        
        <div className="flex items-center space-x-3">
          <div className="w-10 h-10 bg-primary/10 rounded-full flex items-center justify-center">
            <Icon name="GitCompare" size={20} className="text-primary" strokeWidth={2} />
          </div>
          <div className="text-left">
            <h3 className="font-heading text-lg font-semibold text-foreground">
              Photo Comparison
            </h3>
            <p className="font-body text-sm text-muted-foreground">
              Compare pre-rental and return inspection photos
            </p>
          </div>
        </div>
        <Icon
          name={isExpanded ? 'ChevronUp' : 'ChevronDown'}
          size={20}
          strokeWidth={2}
          className="text-muted-foreground" />
        
      </button>

      {/* Content */}
      {isExpanded &&
      <div className="p-4 border-t border-border space-y-4">
          {/* Section Selector */}
          <div className="flex flex-wrap gap-2">
            {sectionsWithComparison?.map((section) =>
          <Button
            key={section?.id}
            variant={selectedSection === section?.id ? 'default' : 'outline'}
            size="sm"
            onClick={() => setSelectedSection(section?.id)}
            iconName={section?.icon}>
            
                {section?.title}
              </Button>
          )}
          </div>

          {/* Comparison Grid */}
          {selectedSection &&
        <div className="space-y-4">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {/* Pre-Rental Photos */}
                <div>
                  <div className="flex items-center space-x-2 mb-3">
                    <Icon name="Calendar" size={16} className="text-muted-foreground" strokeWidth={2} />
                    <h4 className="font-heading text-sm font-semibold text-foreground">
                      Pre-Rental Condition
                    </h4>
                  </div>
                  <div className="space-y-3">
                    {preRentalPhotos?.[selectedSection]?.map((photo) =>
                <div key={photo?.id} className="aspect-video rounded-lg overflow-hidden bg-muted border border-border">
                        <img
                    src={photo?.url}
                    alt={photo?.alt}
                    className="w-full h-full object-cover" />
                  
                      </div>
                )}
                  </div>
                </div>

                {/* Return Inspection Photos */}
                <div>
                  <div className="flex items-center space-x-2 mb-3">
                    <Icon name="Clock" size={16} className="text-muted-foreground" strokeWidth={2} />
                    <h4 className="font-heading text-sm font-semibold text-foreground">
                      Return Inspection
                    </h4>
                  </div>
                  <div className="space-y-3">
                    {inspectionData?.[selectedSection]?.photos?.slice(0, 2)?.map((photo) =>
                <div key={photo?.id} className="aspect-video rounded-lg overflow-hidden bg-muted border border-border">
                        <img
                    src={photo?.preview}
                    alt={`Return inspection ${selectedSection}`}
                    className="w-full h-full object-cover" />
                  
                      </div>
                )}
                  </div>
                </div>
              </div>

              {/* Notes Comparison */}
              {inspectionData?.[selectedSection]?.notes &&
          <div className="bg-muted rounded-md p-4">
                  <div className="flex items-start space-x-2">
                    <Icon name="FileText" size={16} className="text-primary mt-0.5" strokeWidth={2} />
                    <div className="flex-1">
                      <p className="font-body text-sm font-medium text-foreground mb-1">
                        Return Inspection Notes:
                      </p>
                      <p className="font-body text-sm text-muted-foreground">
                        {inspectionData?.[selectedSection]?.notes}
                      </p>
                    </div>
                  </div>
                </div>
          }
            </div>
        }

          {!selectedSection &&
        <div className="text-center py-8">
              <Icon name="GitCompare" size={48} className="text-muted-foreground mx-auto mb-3" strokeWidth={1.5} />
              <p className="font-body text-sm text-muted-foreground">
                Select a section above to compare photos
              </p>
            </div>
        }
        </div>
      }
    </div>);

};

export default ComparisonView;